module.exports = __webpack_public_path__ + "img/obras4.2d1aa4d9.svg";